import { __init_free_slider } from './slider';
import { __trigger_small_menu_active_by_id } from './menu';
/*
 * Full page scroll functionality
 */

export let __handle_key_navigation = async function () {
    document.addEventListener('keydown', async function (event) {
        if (`${event.code}` == 'ArrowDown' || `${event.code}` == 'ArrowUp') {
            let active_section = $('.js--section-item-link.active');

            if ($(active_section).length > 0) {
                let active_index = parseInt($(active_section).attr('data-index'));
                if (`${event.code}` == 'ArrowDown') {
                    let number_sections = $('.js--section-item-link').length;
                    if (active_index < number_sections - 1) {
                        let next_index = (active_index + 1).toString();
                        let next_section = $('.js--section-item-link[data-index="' + next_index + '"]');
                        $(next_section).trigger('click');
                    }
                }
                if (`${event.code}` == 'ArrowUp') {
                    if (active_index > 0) {
                        let prev_index = (active_index - 1).toString();
                        let prev_section = $('.js--section-item-link[data-index="' + prev_index + '"]');
                        $(prev_section).trigger('click');
                    }
                }
            }
        }
    });
};

export let __full_page_scroll = async function (settings) {
    const urlParams = window.location.search;

    for (let widget of $('.stmnt--widget')) {
        if ($(widget).hasClass('stmnt--modal')) {
            let elementor_widget = $(widget).parentsUntil('.elementor-section').parent();
            $(elementor_widget).addClass('not-fullpage');
        }
    }

    if (!urlParams.includes('elementor-preview')) {
        let page = $('article').find('.elementor');
        $(page).attr('id', 'fullpagevdwgb');

        for (let section of $(page).find('.elementor-section')) {
            let window_height = $(window).height();
            let section_height = $(section).height();

            if (section_height > window_height) {
                $(section).addClass('normalscroll');
            }
        }

        /*
        // global available fullpage_api variable
        new fullpage('#fullpagevdwgb', {
            // 716351CD-1EE847CD-AAD9EC9A-7452EDA9
            licenseKey: 'gplv3-license',

            //Navigation
            menu: '#myMenu',
            lockAnchors: false,
            anchors: [
                'section1',
                'section2',
                'section3',
                'section4',
                'section5',
                'section6',
                'section7',
                'section8',
                'section9',
                'section10',
                'section11',
                'section12',
                'section13',
                'section14',
                'section15',
                'section16',
                'section17',
                'section18',
                'section19',
                'section20',
            ],
            navigation: true,
            navigationPosition: 'right',
            navigationTooltips: [],
            showActiveTooltip: false,
            slidesNavigation: false,
            slidesNavPosition: 'bottom',

            //Scrolling
            css3: true,
            scrollingSpeed: 800,
            autoScrolling: true,
            fitToSection: false,
            fitToSectionDelay: 400,
            scrollBar: false,
            easing: 'easeInOutCubic',
            easingcss3: 'ease-in-out',
            loopBottom: false,
            loopTop: false,
            loopHorizontal: false,
            continuousVertical: false,
            continuousHorizontal: false,
            scrollHorizontally: false,
            interlockedSlides: false,
            dragAndMove: false,
            offsetSections: false,
            resetSliders: false,
            fadingEffect: false,
            normalScrollElements: '.test',
            scrollOverflow: true,
            scrollOverflowReset: true,
            scrollOverflowOptions: null,
            touchSensitivity: 50,
            bigSectionsDestination: null,

            //Accessibility
            keyboardScrolling: true,
            animateAnchor: true,
            recordHistory: true,

            //Design
            controlArrows: true,
            verticalCentered: true,
            sectionsColor: [],
            paddingTop: '0',
            paddingBottom: '0',
            fixedElements: '',
            responsiveWidth: 0,
            responsiveHeight: 0,
            responsiveSlides: true,
            parallax: false,
            parallaxOptions: { type: 'reveal', percentage: 62, property: 'translate' },
            dropEffect: false,
            dropEffectOptions: { speed: 2300, color: '#F82F4D', zIndex: 9999 },
            waterEffect: false,
            waterEffectOptions: { animateContent: true, animateOnMouseMove: true },
            cards: false,
            cardsOptions: { perspective: 100, fadeContent: true, fadeBackground: true },

            //Custom selectors
            sectionSelector: '.elementor-section:not(.not-fullpage)',
            slideSelector: '.elementor-section:not(.not-fullpage)',

            lazyLoading: true,

            //events
            onLeave: function (origin, destination, direction) {},
            afterLoad: function (origin, destination, direction) {},
            beforeLeave: function (origin, destination, direction, trigger) {
                console.log('now');
            },
            afterRender: function () {},
            afterResize: function (width, height) {},
            afterReBuild: function () {},
            afterResponsive: function (isResponsive) {},
            afterSlideLoad: function (section, origin, destination, direction) {},
            onSlideLeave: function (section, origin, destination, direction) {},
            onScrollOverflow: function (section, slide, position, direction) {
                console.log('scroll overflow');
            },
        });
        */

        $.fn.isInViewport = function (space_element, space_window) {
            var elementTop = $(this).offset().top + space_element;
            var elementBottom = elementTop + $(this).outerHeight();

            var viewportTop = $(window).scrollTop() + space_window;
            var viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        };

        $(document).ready(async function () {
            let data = [];
            let index = 0;
            for (let widget of $('.elementor-section:not(.not-fullpage)')) {
                let widget_offset_top = $(widget).offset().top;
                let widget_height = $(widget).outerHeight();

                $(widget).attr('offset-top', widget_offset_top);

                if (widget_height > 50) {
                    data.push({
                        index: index,
                        offset: widget_offset_top,
                        element: widget,
                        height: widget_height,
                        end_offset: widget_offset_top + widget_height,
                    });
                    index++;
                }
            }

            // data = data.reverse();

            let stop = false;
            var last_scroll_top = 0;

            let __autoplay_video = async function (section) {
                let video = $(section).find('video');

                if ($(video).length) {
                    if (!$(video).hasClass('already-played')) {
                        if ($(video).attr('autoplay') == 'autoplay') {
                            if (video[0].paused) {
                                video[0].volume = 0;
                                video[0].play();
                            }
                        }
                    }
                }
            };

            $(window).on('scroll', function (event) {
                window.requestAnimationFrame(async () => {
                    let autoscroll = await settings.__get_autoscroll();

                    if (!autoscroll) {
                        if (stop) {
                            event.preventDefault();
                            // console.log('stop');
                        } else {
                            let space = 30;
                            let scroll_top = $(window).scrollTop();
                            let window_height = $(window).height();

                            if (scroll_top > last_scroll_top) {
                                // downscroll code
                                // console.log('down');
                                let found_element = null;
                                found_element = await data.find((element) => $(element.element).isInViewport(0, 0));
                                if (found_element != null && found_element != undefined) {
                                    let section_id_found = $(found_element.element).attr('data-id');
                                    await __trigger_small_menu_active_by_id(section_id_found);
                                    // console.log(found_element);
                                    let index_after = found_element.index + 1;

                                    if (index_after <= data.length - 1) {
                                        let next_element = data[index_after];
                                        if (next_element != undefined) {
                                            if ($(next_element.element).isInViewport(space, 0)) {
                                                event.preventDefault();

                                                // Hide scroll more button
                                                let scroll_more_button = $(found_element.element).find('.scroll--hide');
                                                if (scroll_more_button.length > 0) {
                                                    $(scroll_more_button).addClass('hide');
                                                }
                                                await __autoplay_video(next_element.element);
                                                let section_id = $(next_element.element).attr('data-id');

                                                /*
                                                $('html, body')
                                                    .stop()
                                                    .animate({ scrollTop: $(next_element.element).offset().top }, 400);
                                                 */
                                                await __trigger_small_menu_active_by_id(section_id);
                                            }
                                        }
                                    }

                                    stop = true;

                                    setTimeout(async function () {
                                        stop = false;
                                    }, 450);
                                }
                            } else {
                                // upscroll code
                                // console.log('up');

                                $('html, body').stop();

                                let found_element = null;
                                found_element = await data.find((element) => $(element.element).isInViewport(0, space));
                                if (found_element != null && found_element != undefined) {
                                    let section_id = $(found_element.element).attr('data-id');

                                    let scroll_more_button = $(found_element.element).find('.scroll--hide');
                                    if (scroll_more_button.length > 0) {
                                        $(scroll_more_button).removeClass('hide');
                                    }
                                    await __trigger_small_menu_active_by_id(section_id);
                                    await __autoplay_video(found_element.element);
                                    // console.log(found_element);
                                    /*
                                    let index_before = found_element.index - 1;
                                    if (index_before >= 0) {
                                        let prev_element = data[index_before];
                                        if (prev_element != undefined) {
                                            if ($(prev_element.element).isInViewport(0, space)) {
                                                event.preventDefault();
                                                $('html, body').animate({ scrollTop: prev_element.end_offset }, 800);
                                            }
                                        }
                                    }

                                    stop = true;

                                    setTimeout(async function () {
                                        stop = false;
                                    }, 850);
                                    */
                                }
                            }
                            last_scroll_top = scroll_top <= 0 ? 0 : scroll_top;
                        }
                    }
                })
            });
        });
    }
};
